module.exports = __webpack_public_path__ + "img/英文.33f1f033.png";